import React from 'react';
import styled, { css } from 'styled-components';
import { useAnimationOnScroll } from '../hooks/useAnimationOnScroll';
import { fadeIn, slideUp, fadeInLeft, fadeInRight } from '../theme/animations';

interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: 'fadeIn' | 'slideUp' | 'fadeInLeft' | 'fadeInRight';
  delay?: number;
  className?: string;
}

const animations = {
  fadeIn,
  slideUp,
  fadeInLeft,
  fadeInRight,
};

interface AnimatedDivProps {
  $isVisible: boolean;
  $animation: keyof typeof animations;
  $delay: number;
}

const AnimatedDiv = styled.div<AnimatedDivProps>`
  opacity: 0;
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  
  ${props => props.$isVisible && css`
    animation: ${animations[props.$animation]} 0.6s ease-out ${props.$delay}s forwards;
  `}
`;

const AnimatedSection: React.FC<AnimatedSectionProps> = ({ 
  children, 
  animation = 'fadeIn',
  delay = 0,
  className
}) => {
  const { elementRef, isVisible } = useAnimationOnScroll();

  return (
    <AnimatedDiv
      ref={elementRef}
      $isVisible={isVisible}
      $animation={animation}
      $delay={delay}
      className={className}
    >
      {children}
    </AnimatedDiv>
  );
};

export default AnimatedSection;
